import './style.css'

import _ from 'lodash'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import Media from 'react-media'
import { Sticky, StickyContainer } from 'react-sticky'

import NRTBackButton from '../../components/_common/_buttons/BackButton'
import AppContainer from '../../components/_common/_containers/AppContainer'
import ContentContainer from '../../components/_common/_containers/ContentContainer'
import FullScreenContainer from '../../components/_common/_containers/FullScreenContainer'
import NRTCardWithShadow from '../../components/_common/CardWithShadow'
import MCErrorMsg from '../../components/_common/ErrorMsg'
import Author from '../../components/_courses/Author'
import CourseAuthor from '../../components/_courses/CourseAuthor'
import CourseExcerpt from '../../components/_courses/CourseExcerpt'
import CourseHeader from '../../components/_courses/CourseHeader'
import CourseInfo from '../../components/_courses/CourseInfo'
import NRTCourseRelease from '../../components/_courses/CourseRelease'
import CourseSignIn from '../../components/_courses/CourseSignIn/CourseSignIn'
import MCLoading from '../../components/_minha-central/Loading'
import { ClassTypesEnum } from '../../enums/ClassTypesEnum'
import moment from '../../helpers/moment'
import { getParsedPriceValues } from '../../helpers/price'
import { productType } from '../../helpers/product'
import ProductRequests from '../../requests/product-requests'
import ReleaseRequests from '../../requests/release-requests'
import SalePage from '../Sale'


class CourseDetailsPage extends Component {


    state = {
        productData: {},
        releaseData: {},
        release: {},
        lastSearchedId: null,
        awaiting: true,
        error: null,
    }

    componentDidMount() {
        window.scrollTo(0, 0)

        this.setState({
            title: _.get(this.props.context, 'systemConfigParameterValue.title', ''),
            showAuthorInfo: _.get(this.props.context, 'systemConfigParameterValue.authorInfo', '')
        })
        this.props.context.set({saleGuests: null})
        this.getCourseData(this.props.match.params.id)
    }


    componentDidUpdate() {

        if (this.props.match.params.id !== this.state.lastSearchedId)
            this.getCourseData(this.props.match.params.id)
    }


    getCourseData(id) {
        const type = id[0] // busca o tipo (p - produto , r - release)
        const code = id.substring(1)

        this.setState({
            awaiting: true,
            lastSearchedId: id,
        })

        if (type === 'p') {


            ProductRequests.get(code)
                .then(product => this.showProduct(product))
                .then(() => this.setState({awaiting: false}))
                .catch(error => {
                    console.error(error)
                    this.setState({
                        awaiting: false,
                        error: 'Ocorreu um erro ao tentar obter as informações deste curso.'
                    })

                })

        } else {


            ReleaseRequests.get(code)
                .then(release => this.showRelease(release))
                .then(() => this.setState({awaiting: false}))
                .catch(error => {
                    console.error(error)
                    this.setState({
                        awaiting: false,
                        error: 'Ocorreu um erro ao tentar obter as informações desta turma.'
                    })

                })
        }


    }


    showRelease(release) {

        const releaseData = {}
        releaseData.title = `${this.formatReleaseNumber(release.number)} - ${release.name}`
        releaseData.image = release.mainImageUrl || release.product.mainImageUrl
        releaseData.authors = release.personOwners
        const prdReleaseDescription = release.description ? release.description + ' ' : ''
        const prdDescription = release.product.description ? release.product.description : ''
        releaseData.description = `${prdReleaseDescription}${prdDescription}`
        releaseData.startDate = release.startDate
        releaseData.startTime = release.startTime
        releaseData.endDate = release.endDate
        releaseData.endTime = release.endTime
        releaseData.workload = release.workload
        releaseData.address = release.address

        // PRECO
        const priceValues = getParsedPriceValues(release.price)

        this.setState({
            release,
            soldOut: CourseDetailsPage.hasReleaseSoldOut(release),
            releaseData: {
                ...releaseData,
                ...priceValues,

            }
        })
    }

    showProduct(product) {
        const productData = {}
        productData.title = `${product.name}`
        productData.image = product.mainImageUrl
        productData.description = product.description

        if (!product.productReleases) {
            console.warn('Produto sem releases')
            return
        }

        if (productType(product.type) === 'Produto' || productType(product.type) === 'Serviço') {
            productData.releases = product.productReleases.filter((release) => release.quantity === null || release.quantity - release.soldQuantity > 0);
        } else if (productType(product.type) === 'Curso') {
            productData.releases = product.productReleases.filter(release => moment(release.startDate).isSameOrAfter(moment()))
        }

        productData.releases.sort((a, b) => {

            if (a.startDate > b.startDate) {
                return 1
            } else {
                return -1
            }

            if (a.startTime > b.startTime) {
                return 1
            } else {
                return -1
            }

        })

        this.setState({productData})
    }


    formatReleaseNumber = (number) => {
        return `${number.slice(4)} / ${number.slice(0, 4)}`
    }


    onSignInClick = () => {
        this.props.context.set({
                saleRelease: this.state.release,
                saleCourseData: this.state.releaseData
            },
            () => {
                this.props.history.push(`/venda/${this.state.release.code}/${SalePage.AUTHENTICATE_STEP}`)
            })

    }


    onSelectRelease = code => {
        this.props.history.push('/curso/r' + code)
    }

    static hasReleaseSoldOut(release) {
        const {quantity, soldQuantity, product} = release
        const {classType} = product


        // curso virtual e numero de vagas nao foram preenchidas no admin.
        if ((classType === ClassTypesEnum.Virtual && quantity === null) || product.type === 2)
            return false
        // else
        return quantity - soldQuantity <= 0
    }


    /**
     * Metodo para pegar os parametros de busca do iframe do google maps.
     *
     */
    getMapAddressConfig = (address) => {

        if (!address)
            return {showMap: false}


        const {
            neighborhood,
            number,
            street,
            city,
            state,
        } = address

        const addr = `${street || ''} ${number || ''} ${neighborhood || ''} ${city || ''} ${state || ''}`.trim()


        const zoom = !!neighborhood ? 15 : 13

        return {
            showMap: addr.length > 0,
            address: addr,
            zoom,
        }
    }

    render() {

        const {
            match,
        } = this.props


        const {
            title,
            awaiting,
            releaseData,
            productData,
            error,
            soldOut,
            showAuthorInfo
        } = this.state

        const path = this.props.location.pathname;
        const contentType = path.slice(1, path.lastIndexOf('/'));
        const contentsTypes = {
            servico: 'serviço',
            produto: 'produto',
            curso: 'curso'
        }

        if (error)
            return <MCErrorMsg>{error}</MCErrorMsg>

        const showingRelease = match.params.id[0] === 'r'

        if (awaiting)
            return (<MCLoading/>)


        const {
            title: releaseTitle,
            image: releaseImage,
            description: releaseDescription,
            authors,
            startDate,
            endDate,
            startTime,
            endTime,
            modules,
            sightValue,
            maxInstallments,
            installmentValue,
            workload,
            address,

        } = releaseData

        const {
            title: productTitle,
            image: productImage,
            description: productDescription,
            releases
        } = productData

        const titleToDisplay = showingRelease ? releaseTitle : productTitle
        const image = showingRelease ? releaseImage : productImage
        const description = showingRelease ? releaseDescription : productDescription
        const authorNames = !!authors ? authors.map(a => a.name).join(', ') : ''    
        const hasReleases = !!releases
        const courseDescription = (description === null) ? '': description

        const mapConfig = this.getMapAddressConfig(address)

        return (
            <AppContainer {...this.props}>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>{title} | {contentsTypes[contentType]}</title>
                </Helmet>
                <FullScreenContainer className={'nrt-course-page'}>

                    <CourseHeader
                        title={titleToDisplay}
                        authorNames={authorNames}
                        image={image}

                    />

                    <ContentContainer center>
                        <StickyContainer>

                            <div className="container-detalhes-page">
                                <div className='nrt-ead-course-page'>

                                    {                                    

                                            <React.Fragment>
                                                <div className="content-section">

                                                    <CourseInfo startDate={startDate}
                                                                endDate={endDate}
                                                                startTime={startTime}
                                                                endTime={endTime}
                                                                workload={workload}

                                                    />
                                                </div>
                                                {   
                                                    courseDescription && 
                                                        <div className={'content-section'}>

                                                            <h2>{`Detalhes do ${contentsTypes[contentType]}`}</h2>

                                                            <NRTCardWithShadow>
                                                                <CourseExcerpt html={(courseDescription + '')}/>
                                                            </NRTCardWithShadow>
                                                        </div>
                                                }
                                                
                                            </React.Fragment>
                                     
                                    }


                                    {
                                        !showingRelease &&
                                        <div className={'content-section'}

                                             style={{
                                                 marginTop: hasReleases ? 0 : '5rem'
                                             }}
                                        >
                                            {contentsTypes[contentType] == 'curso' ? <h2>Turmas</h2> : <h2>Versões</h2>}
                                            {
                                                !releases ?
                                                    <div>
                                                        <p>Não há turmas programadas para este curso no momento.</p>
                                                        <div style={{
                                                            textAlign: 'center',
                                                            display: 'flex',
                                                            marginTop: '3rem',
                                                            flex: 1,
                                                            justifyContent: 'center',
                                                        }}>
                                                            <NRTBackButton
                                                                onClick={() => {
                                                                    this.props.history.push(`/`)
                                                                }}/>
                                                        </div>
                                                    </div>
                                                    :
                                                    (
                                                        <div style={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                        }}>
                                                            {
                                                                releases.filter(rel => rel.published && rel.active)
                                                                    .map(rel => {

                                                                        return (
                                                                            <NRTCourseRelease
                                                                                key={`release_${rel.code}`}
                                                                                id={rel.code}
                                                                                title={rel.name}
                                                                                // location={formatAddress(rel.empAddress)}
                                                                                value={rel.price ? rel.price.sightValue : null}
                                                                                onClick={this.onSelectRelease}
                                                                                startDate={rel.startDate}
                                                                                endDate={rel.endDate}
                                                                                startTime={rel.startTime}
                                                                                endTime={rel.endTime}
                                                                            />
                                                                        )
                                                                    })
                                                            }
                                                        </div>
                                                    )
                                            }
                                        </div>
                                    }
                                    {
                                        showingRelease && modules &&
                                        <div className={'content-section'}>
                                            <h2>Módulos do curso</h2>
                                            {/*{modules}*/}
                                        </div>
                                    }


                                    {   
                                        showAuthorInfo &&
                                        showingRelease &&
                                        authors &&
                                        authors.length > 0 &&                                       
                                        this.props.context.credentials.schema !== 'treinamento' &&
                                        contentType == 'curso' &&
                                        <div className={'content-section'}>
                                            <h2>Instrutores</h2>

                                             <CourseAuthor>{
                                                        authors.map(author => (

                                                                <Author
                                                                    showAuthorEmail={true}
                                                                    key={`author_${author.code}`} {...author} />
                                                            )
                                                        )}
                                             </CourseAuthor>
                                              
                                            
                                        </div>
                                    }


                                    {
                                        mapConfig.showMap &&
                                        <div className={'content-section'}>
                                            <h2>Localização</h2>
                                            <NRTCardWithShadow>


                                                <div className="map">
                                                    <div className="gmap_canvas">
                                                        <iframe id="gmap_canvas"
                                                                src={`https://maps.google.com/maps?q=${mapConfig.address}&t=&z=${mapConfig.zoom}&ie=UTF8&iwloc=&output=embed`}
                                                                frameBorder="0" scrolling="no" marginHeight="0"
                                                                marginWidth="0"/>
                                                    </div>
                                                </div>

                                            </NRTCardWithShadow>
                                        </div>
                                    }

                                </div>


                            </div>

                            {
                                showingRelease &&
                                <Media query="(max-width: 955px)">

                                    {
                                        matches =>
                                            matches ? (
                                                    <CourseSignIn
                                                        sightValue={sightValue}
                                                        maxInstallments={maxInstallments !== 1 ? maxInstallments : 0}
                                                        installmentValue={installmentValue}
                                                        onClick={this.onSignInClick}
                                                        soldOut={soldOut}
                                                    />
                                                )
                                                :
                                                (
                                                    <Sticky>
                                                        {
                                                            ({
                                                                 style,

                                                                 // the following are also available but unused in this example
                                                                 isSticky,
                                                                 wasSticky,
                                                                 distanceFromTop,
                                                                 // distanceFromBottom
                                                                 //calculatedHeight
                                                             }) => {
                                                                const top = distanceFromTop < 80 ? -distanceFromTop + 100 : -100
                                                                return (
                                                                    <aside style={{
                                                                        zIndex: 9999,
                                                                        transition: 'all .4s ease-out',
                                                                        top,
                                                                        transform: 'translate3d(.3rem , 0 , 0 )',
                                                                        position: 'absolute',
                                                                        right: '2rem',
                                                                        minWidth: '20rem',


                                                                    }}>
                                                                        <CourseSignIn
                                                                            sightValue={sightValue}
                                                                            maxInstallments={
                                                                                maxInstallments !== 1 ? maxInstallments : 0
                                                                            }
                                                                            installmentValue={installmentValue}
                                                                            onClick={this.onSignInClick}
                                                                            soldOut={soldOut}
                                                                        />
                                                                    </aside>
                                                                )
                                                            }
                                                        }
                                                    </Sticky>
                                                )
                                    }


                                </Media>
                            }


                        </StickyContainer>


                    </ContentContainer>


                </FullScreenContainer>
            </AppContainer>
        )
    }
}


export default CourseDetailsPage



// WEBPACK FOOTER //
// ./src/_pages/CourseDetails/index.js